import {rootInstance} from './axiosConfig'; // Cambiar importación

const REFRESH_URL = 'refresh/';

let sessionExpiredCallback: (() => void) | null = null;

export const onSessionExpired = (callback: () => void) => {
    sessionExpiredCallback = callback;
};

/**
 * Función para renovar el access token.
 * Dado que los tokens se almacenan en cookies HttpOnly, el cliente no
 * puede acceder a ellos directamente; se confía en que el navegador envíe
 * las cookies automáticamente en cada solicitud.
 */
export const refreshAccessToken = async (): Promise<void> => {
    try {
        await rootInstance.post(REFRESH_URL); // Sin withCredentials (ya configurado)
        console.log('Token renovado exitosamente');
    } catch (error: any) {
        console.error('El refresh token ya no es válido. Cerrando sesión.');
        handleSessionExpired();
        throw new Error('Refresh token inválido');
    }
};
/**
 * Manejar sesión expirada redirigiendo o llamando al callback correspondiente.
 */
export const handleSessionExpired = () => {
    if (sessionExpiredCallback) {
        sessionExpiredCallback();
    } else {
        window.location.href = '/login';
    }
};

/**
 * Función auxiliar para realizar solicitudes autenticadas.
 * Se asume que el navegador enviará las cookies de sesión automáticamente.
 */
export const handleRequestWithAuth = async (
    requestFunc: () => Promise<any>
): Promise<any> => {
    try {
        return await requestFunc();
    } catch (error: any) {
        if (error.response?.status === 401) {
            console.warn('Token expirado, intentando renovarlo...');
            await refreshAccessToken();
            console.log('Reintentando solicitud tras renovación de token');
            return await requestFunc();
        }
        // Conservar status y cuerpo (errores de campos, mensajes SIN y 207).
        // Los consumidores deciden cómo presentarlos sin perder el detalle.
        throw error;
    }
};


